<template>
  <div id="transfer-update" class="row">
    <form id="update-transfer-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <div class="expanded button-group">
        <input type="submit" name="submit_approve" :value="'Approve'|t" class="success button" @click="setOperation('approve')" />
        <input type="submit" name="submit_cancel" :value="'Cancel'|t" class="button" @click="setOperation('cancel')" />
        <input type="submit" name="submit_reject" :value="'Reject'|t" class="alert button" @click="setOperation('reject')" />
      </div>
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'UpdateForm',
    props: {
      domain: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        op: null,
      }
    },
    methods: {
      setOperation(op) {
        this.op = op;
      },
      submitForm() {
        let request = {
          domain_name: this.domain,
        };
        switch (this.op) {
          case "approve":
            api.approveDomainTransfer(
              request,
              data => {
                this.$store.commit('messages/addMessage', {
                  type: "status",
                  message: "Transfer for domain %s has been approved.",
                  args: [data.domain]
                }, {root: true});
                router.push({name: 'transfer.collection'});
              }
            );
            break;

          case "cancel":
            api.cancelDomainTransfer(
              request,
              data => {
                this.$store.commit('messages/addMessage', {
                  type: "status",
                  message: "Transfer for domain %s has been cancelled.",
                  args: [data.domain]
                }, {root: true});
                router.push({name: 'transfer.collection'});
              }
            );
            break;

          case "reject":
            api.rejectDomainTransfer(
              request,
              data => {
                this.$store.commit('messages/addMessage', {
                  type: "status",
                  message: "Transfer for domain %s has been rejected.",
                  args: [data.domain]
                }, {root: true});
                router.push({name: 'transfer.collection'});
              }
            );
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/transfer/UpdateForm.vue